import { render, staticRenderFns } from "./ProgramCourse.vue?vue&type=template&id=513abdea&scoped=true"
import script from "./ProgramCourse.vue?vue&type=script&lang=js"
export * from "./ProgramCourse.vue?vue&type=script&lang=js"
import style0 from "./ProgramCourse.vue?vue&type=style&index=0&id=513abdea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513abdea",
  null
  
)

export default component.exports